import React, {Fragment, useState} from "react";
import { Link } from "react-router-dom";
// database
import * as DATABASE from 'db';
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Drawer from "@material-ui/core/Drawer";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
// core components
import styles from "assets/jss/material-kit-pro-react/components/headerStyle.js";
// assets
import WordLogo from "assets/img/logos/logo-word.svg";
import WordLogoLong from "assets/img/logos/logo-word-long.svg";

const useStyles = makeStyles(styles);

export default function Header(props) {
  let bannerChecker = localStorage.getItem(DATABASE.BANNER.name);
  if(bannerChecker == null){
    bannerChecker = true;
    localStorage.setItem(DATABASE.BANNER.name, bannerChecker);
  } else {
    bannerChecker = JSON.parse(bannerChecker);
  }
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const classes = useStyles();
  const [bannerData, setBannerData] = useState({showBanner: DATABASE.BANNER.show ? bannerChecker : false});
  React.useEffect(() => {
    if (props.changeColorOnScroll) {
      window.addEventListener("scroll", headerColorChange);
    }
    return function cleanup() {
      if (props.changeColorOnScroll) {
        window.removeEventListener("scroll", headerColorChange);
      }
    };
  });
  const handleBannerClose = () => {
    setBannerData({...bannerData, showBanner: false });
    localStorage.setItem(DATABASE.BANNER.name, false);
  }
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const headerColorChange = () => {
    const { color, changeColorOnScroll } = props;

    const windowsScrollTop = window.pageYOffset;
    if (windowsScrollTop > changeColorOnScroll.height) {
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[changeColorOnScroll.color]);
    } else {
      document.body
        .getElementsByTagName("header")[0]
        .classList.add(classes[color]);
      document.body
        .getElementsByTagName("header")[0]
        .classList.remove(classes[changeColorOnScroll.color]);
    }
  };
  const { color, links, fixed, absolute } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed
  });
  return (
    <Fragment>
      <div 
        className={classes.bannerWrapper} 
        style={{ backgroundColor: DATABASE.BANNER.backgroundColor }}
      >
        <div className={classes.bannerTextWrapper}>
          {bannerData.showBanner && 
            <a 
              className={classes.bannerTextLink} 
              href={DATABASE.BANNER.link} 
              rel="noopener noreferrer" 
              style={{ color: DATABASE.BANNER.textColor }}
            >
              <h4 className={classes.bannerText}>
                {DATABASE.BANNER.title} <span style={{ textDecoration: 'underline' }}>{DATABASE.BANNER.clickMe}</span>
              </h4>
            </a>
          }
        </div>
        <div className={classes.bannerButtonWrapper}>
          <button 
            className={classes.bannerButton} 
            onClick={handleBannerClose} 
            style={{ 
              backgroundColor: DATABASE.BANNER.backgroundColor, 
              color: DATABASE.BANNER.textColor 
            }}
          >
            <h4 className={classes.bannerIcon}>x</h4>
          </button>
        </div>
      </div>
      <div style={{ clear: 'both' }}></div>
      <AppBar className={appBarClasses} style={{ marginTop: bannerData.showBanner ? window.innerWidth > 800 ? 50 : 50 : 0 }}>
        <Toolbar className={classes.container}>
          <Button className={classes.title} style={{ backgroundColor: 'white' }}>
            <Link to="/">
              {window.innerWidth > 800 ?
              <img src={WordLogo} style={{height: 70}} alt="Utah Swim Academy" />
              :
              <img src={WordLogoLong} style={{width: window.innerWidth - 100}} alt="Utah Swim Academy" />
              }
            </Link>
          </Button>
          <Hidden mdDown implementation="css" className={classes.hidden}>
            <div className={classes.collapse}>{links}</div>
          </Hidden>
          <Hidden lgUp>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
            >
              <Menu />
            </IconButton>
          </Hidden>
        </Toolbar>
        <Hidden lgUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={"right"}
            open={mobileOpen}
            classes={{
              paper: classes.drawerPaper
            }}
            onClose={handleDrawerToggle}
          >
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
              className={classes.closeButtonDrawer}
            >
              <Close />
            </IconButton>
            <div className={classes.appResponsive}>{links}</div>
          </Drawer>
        </Hidden>
      </AppBar>
    </Fragment>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  links: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  // this will cause the sidebar to change the color from
  // props.color (see above) to changeColorOnScroll.color
  // when the window.pageYOffset is heigher or equal to
  // changeColorOnScroll.height and then when it is smaller than
  // changeColorOnScroll.height change it back to
  // props.color (see above)
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark"
    ]).isRequired
  })
};

Header.defaultProp = {
  color: "white"
};
